export default __webpack_public_path__ + "static/onedriveLogo-429c5454f33d906b64d6e8cf9dda4054.svg";